import { render, staticRenderFns } from "./TextEditor.vue?vue&type=template&id=0d21e5a2&"
import script from "./TextEditor.ts?vue&type=script&lang=ts&"
export * from "./TextEditor.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports